export default "__VITE_ASSET__CC4V4ted__"